const setCollectionDocument = async (collectionRef, data, id) => {
  await collectionRef.doc(id).set(data);
};
export default setCollectionDocument;
